<template>
  <li class="reference-list-item" :id="`ref${data.order}`">
    <a class="reference-link" href="#" @click.prevent="scrollToElement(`p-ref${data.order}`)">
      [{{ data.order }}]
    </a>
    <div class="reference-text">
      <RichText :value="data.referenceText" />
    </div>
  </li>
</template>

<script lang="ts" setup>
import type { ReferenceModel } from '~/models'

const { scrollToElement } = useSmoothScroll()
const props = defineProps<{ model: ReferenceModel }>()

const data = {
  order: props.model.elements.referenceOrderNumber.value,
  referenceText: props.model.elements.referenceText.value
}
</script>
